<template>
  <div>
    <div v-show="!imgSrc">
      <vue-loading v-if="loading" color="#004250" background-color="rgba(0,0,0,0.0)"
        style="margin:auto; margin-top: 20vh; left:0; right:0; top:0; bottom:0; z-index: 9999;" :active="loading"
        :width="60" :height="60" :is-full-page="false" />
      <div class="items-center flex flex-col bg-white w-full">
        <div class="main--container mt-4 shadow w-full bg-white">
          <zt-list-item :title="metadata.nombre" class="mt-2">
            <template slot="icon">
              <zt-icon name="file" class="" />
            </template>
          </zt-list-item>
        </div>
      </div>
      <template v-if="loading === false">
        <template v-for="(item, key) in documentsToUpload">
          <transition :key="item.order" name="fade">
            <div :key="item.order">
              <div class="pdfShowContainer mt-4" v-if="item.value !== '' && item.hasOwnProperty('file')">
                <div class="imageContainerDashboard" v-if="validImage(item)">
                  <img class="imageContentDashboard" :src="item.file.UrlOnLoad" alt="" />
                </div>
                <div v-else-if="item.mimeType === 'application/pdf'" class="pdf-thumb">
                  <zt-pdf-viewer
                    :ref="`ztPDFViewer_${key}`"
                    :src="item.file.UrlOnLoad"
                    :page="1"
                    :show-control="false"
                    @page-count="fitPdfThumb(key)"
                  ></zt-pdf-viewer>
                </div>
              </div>
              <div v-else class="flex flex-column center mt-4">
                <div class="filepicker-section w-full">
                  <div class="left-picker" @click="showFileChooseWindow(key)">
                    <div class="imageUpload"></div>
                    <div class="uploadTitles">{{ imageText }}</div>
                  </div>
                  <div class="lineSeparator"></div>
                  <div class="right-picker" @click="choosePdfFile(key)">
                    <div class="pdfUpload"></div>
                    <div class="uploadTitles">{{ pdfText }}</div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
          <div class="loadOptionWrapper" :key="item.order">
            <div class="w-full flex justify-center">
              <div class="w-1/3 flex flex-wrap justify-center" v-if="item.value !== ''"
                @click="deleteChoosenFile(key, item)">
                <span class="loadOptionIcon">
                  <svg width="19" height="24" viewBox="0 0 19 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M18.99 5.38C18.98 5.35 18.97 5.31 18.96 5.28C18.96 5.27 18.95 5.27 18.95 5.26C18.93 5.23 18.91 5.2 18.89 5.17L13.9 0.11C13.88 0.09 13.85 0.06 13.82 0.05C13.81 0.05 13.81 0.04 13.8 0.04C13.77 0.03 13.74 0.01 13.7 0.01H13.69C13.66 0 13.64 0 13.61 0H2.01C0.9 0 0 0.91 0 2.03V21.96C0 23.09 0.9 24 2.01 24H16.99C18.1 24 19 23.09 19 21.97V5.46C19 5.43 19 5.41 18.99 5.38ZM14.01 1.97L17.1 5.08L15.23 5.06C14.56 5.06 14.01 4.51 14.01 3.82V1.97ZM17.88 21.97C17.88 22.37 17.32 22.91 16.99 22.91H2.01C1.68 22.91 1.12 22.36 1.12 21.97V2.03C1.12 1.63 1.4 1.17 2.01 1.17H12.85V3.81C12.85 5.25 13.61 5.99 15.22 5.99H17.88V21.97Z"
                      fill="#E4527F" />
                    <path
                      d="M13.41 15.6999L12.52 15.8799C12.38 15.9099 12.25 15.8199 12.23 15.6799C12.2 15.5399 12.29 15.3999 12.43 15.3799L14.15 15.0299L14.39 16.8899C14.41 17.0299 14.31 17.1599 14.18 17.1799C14.05 17.1999 13.92 17.0999 13.9 16.9599L13.78 16.0699L13.41 15.6999Z"
                      fill="#E4527F" stroke="#E4527F" stroke-width="0.5" stroke-miterlimit="10" />
                    <path
                      d="M6.51 10.1199C6.65 10.0899 6.78 10.1799 6.8 10.3199C6.83 10.4599 6.74 10.5999 6.6 10.6199L4.88 10.9699L4.64 9.10986C4.62 8.96986 4.72 8.83986 4.86 8.81986C4.99 8.79986 5.12 8.89986 5.14 9.04986L5.26 9.93986L5.65 10.2899L6.51 10.1199Z"
                      fill="#E4527F" stroke="#E4527F" stroke-width="0.5" stroke-miterlimit="10" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M4.66004 11.6899C4.84004 11.7299 4.96004 11.8999 4.92004 12.0799C4.71004 13.1399 4.87004 14.2399 5.38004 15.1999C5.89004 16.1599 6.72004 16.8999 7.72004 17.3199C8.72004 17.7299 9.83004 17.7799 10.87 17.4699C11.91 17.1499 12.8 16.4799 13.4 15.5799C13.5 15.4299 13.71 15.3799 13.86 15.4899C14.01 15.5899 14.06 15.7999 13.95 15.9499C13.27 16.9799 12.25 17.7499 11.06 18.1099C9.88004 18.4699 8.60004 18.4099 7.46004 17.9399C6.32004 17.4699 5.37004 16.6099 4.79004 15.5199C4.21004 14.4299 4.02004 13.1699 4.26004 11.9499C4.30004 11.7699 4.48004 11.6499 4.66004 11.6899Z"
                      fill="#E4527F" stroke="#E4527F" stroke-width="0.5" stroke-miterlimit="10" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M11.33 8.69988C10.33 8.27988 9.22005 8.20988 8.18005 8.51988C7.14005 8.82988 6.24005 9.47988 5.63005 10.3799C5.53005 10.5299 5.32005 10.5699 5.17005 10.4699C5.02005 10.3699 4.98005 10.1599 5.08005 10.0099C5.77005 8.97988 6.80005 8.22988 7.99005 7.87988C9.18005 7.52988 10.45 7.59988 11.59 8.08988C12.73 8.56988 13.66 9.43988 14.24 10.5399C14.81 11.6399 14.98 12.8999 14.73 14.1099C14.69 14.2899 14.51 14.4099 14.33 14.3699C14.15 14.3299 14.03 14.1499 14.07 13.9699C14.29 12.9099 14.14 11.8099 13.64 10.8499C13.14 9.87988 12.32 9.11988 11.33 8.69988Z"
                      fill="#E4527F" stroke="#E4527F" stroke-width="0.5" stroke-miterlimit="10" />
                  </svg>
                </span>
                <span class="loadOptionText">{{
                  $t(
                    'message.FileUploadComponent.formComponent.replaceFieldShort'
                  )
                }}</span>
              </div>
              <div class="w-1/3 flex flex-wrap justify-center" @click="appendNewFileToMetadata">
                <span class="loadOptionIcon">
                  <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M17.9905 5.38C17.9811 5.35 17.9716 5.31 17.9621 5.28C17.9621 5.27 17.9526 5.27 17.9526 5.26C17.9337 5.23 17.9147 5.2 17.8958 5.17L13.1684 0.11C13.1495 0.09 13.1211 0.06 13.0926 0.05C13.0832 0.05 13.0832 0.04 13.0737 0.04C13.0453 0.03 13.0168 0.01 12.9789 0.01H12.9695C12.9411 0 12.9221 0 12.8937 0H1.90421C0.852632 0 0 0.91 0 2.03V21.96C0 23.09 0.852632 24 1.90421 24H16.0958C17.1474 24 18 23.09 18 21.97V5.46C18 5.43 18 5.41 17.9905 5.38ZM13.2726 1.97L16.2 5.08L14.4284 5.06C13.7937 5.06 13.2726 4.51 13.2726 3.82V1.97ZM16.9389 21.97C16.9389 22.37 16.4084 22.91 16.0958 22.91H1.90421C1.59158 22.91 1.06105 22.36 1.06105 21.97V2.03C1.06105 1.63 1.32632 1.17 1.90421 1.17H12.1737V3.81C12.1737 5.25 12.8937 5.99 14.4189 5.99H16.9389V21.97Z"
                      fill="#E4527F" />
                    <path
                      d="M9.95679 8.65997V11.69H12.6378V13.39H9.95679V16.44H8.11889V13.39H5.45679V11.69H8.12837V8.65997H9.95679Z"
                      fill="#E4527F" />
                  </svg>
                </span>
                <span class="loadOptionText">{{
                  $t(
                    'message.FileUploadComponent.formComponent.addNewFieldShort'
                  )
                }}</span>
              </div>
              <div class="w-1/3 flex flex-wrap justify-center"
                v-if="key + 1 > metadata.json.min_files && key + 1 <= metadata.json.max_files"
                @click="removeFilefromJson(key)">
                <span class="loadOptionIcon">
                  <svg width="17" height="25" viewBox="0 0 17 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6.50911 20.5205C6.51216 20.5205 6.51497 20.5205 6.51802 20.5205C6.77672 20.5152 6.9827 20.2851 6.97802 20.006L6.74368 6.42162C6.73876 6.14277 6.52364 5.91393 6.26634 5.92605C6.00763 5.93136 5.80165 6.16146 5.80634 6.44056L6.04067 20.0249C6.0456 20.3005 6.25462 20.5205 6.50911 20.5205ZM9.93627 20.5205C10.191 20.5205 10.4 20.3005 10.4047 20.0247L10.639 6.44031C10.644 6.16146 10.438 5.9311 10.179 5.9258C10.176 5.9258 10.1732 5.9258 10.1701 5.9258C9.91542 5.9258 9.70639 6.1458 9.7017 6.42162L9.46737 20.006C9.46245 20.2848 9.66843 20.5152 9.92737 20.5205C9.93041 20.5205 9.93346 20.5205 9.93627 20.5205ZM14.54 5.92605C14.2717 5.92125 14.0648 6.13595 14.0566 6.4148L13.9898 8.64889C13.9816 8.92774 14.1845 9.16113 14.4433 9.16996C14.4484 9.16996 14.4536 9.17022 14.4585 9.17022C14.7104 9.17022 14.9185 8.95451 14.9267 8.68122L14.9935 6.44713C15.0017 6.16828 14.7985 5.93489 14.54 5.92605ZM14.4165 10.0565C14.4114 10.0565 14.4062 10.0563 14.4013 10.0563C14.1494 10.0563 13.9413 10.272 13.9331 10.5453L13.5875 22.1262C13.5875 22.6238 13.2123 23.0286 12.7516 23.0286H3.69474C3.23286 23.0286 2.85746 22.6238 2.85722 22.1098L2.38855 6.41429C2.38011 6.13544 2.16874 5.91974 1.90511 5.92555C1.64641 5.93464 1.44347 6.16777 1.45167 6.44662L1.92011 22.1257C1.92011 23.1805 2.71615 24.0385 3.69474 24.0385H12.7516C13.7295 24.0385 14.5248 23.1805 14.5246 22.1418L14.8697 10.5768C14.8779 10.2988 14.675 10.0654 14.4165 10.0565ZM15.7255 3.40023H11.9509L11.5595 1.36416C11.5145 1.12977 11.3228 0.961548 11.1007 0.961548H5.3454C5.12325 0.961548 4.93156 1.12977 4.88657 1.36416L4.49523 3.40023H0.718672C0.459965 3.40023 0.25 3.62654 0.25 3.90539C0.25 4.18425 0.459965 4.41056 0.718672 4.41056H4.87579C4.87579 4.41056 4.87602 4.41056 4.87626 4.41056H11.5675C11.568 4.41056 11.5684 4.41056 11.5689 4.41056C11.5691 4.41056 11.5696 4.41056 11.5701 4.41056H15.7255C15.9842 4.41056 16.1942 4.18425 16.1942 3.90539C16.1942 3.62654 15.9842 3.40023 15.7255 3.40023ZM5.45249 3.40023L5.72713 1.97188H10.7194L10.9941 3.40023H5.45249Z"
                      fill="#E4527F" />
                  </svg>
                </span>
                <span class="loadOptionText">{{
                  $t(
                    'message.FileUploadComponent.formComponent.eliminateFieldShort'
                  )
                }}</span>
              </div>
            </div>
          </div>
        </template>
      </template>
      <div v-if="countDocumentsToUpload === this.documentsToUpload.length && loading === false"
        class="containerButtonsSendDocs">
        <button @click="sendDocsToS3()" class="buttonPrimaryProperties btn btnSendDocProperties" type="submit">
          {{ $t('message.FileUploadComponent.sendDocumentsToS3') }}
        </button>
      </div>
    </div>
    <div class="edit-image" v-show="imgSrc">
      <dwt-capture-image v-if="!isNativeVersion && showDwtCapture" ref="DWTCaptureImage" :complete="doneCompleted" :resourcesPath="resourcePath"
        @change-editormode="editorMode" @register-event="addMbcEvent" />
      <capture-image v-if="isNativeVersion && showNativeCapture" ref="DWTCaptureImage" :complete="doneCompleted"
        @change-editormode="editorMode" @register-event="addMbcEvent" />
      <footer v-show="step === 0" class="pie">
        <div class="employeeInfo footerIcons">
          <button class="buttonCamera" @click="cropImage">
            <em class="icon-Crop"></em>
            <span class="textButtonCamera">{{
              $t(
                'message.FileUploadComponent.cameraComponent.buttons.manualCrop'
              )
            }}</span>
          </button>
          <button class="buttonCamera" @click="rotateImage">
            <em class="icon-Rotate"></em>
            <span class="textButtonCamera">{{
              $t(
                'message.FileUploadComponent.cameraComponent.buttons.rotate'
              )
            }}</span>
          </button>
        </div>
        <div>
          <button class="deleteImage" @click="deleteImage">
            {{
              $t(
                'message.FileUploadComponent.formComponent.eliminateFieldShort'
              )
            }}
          </button>
        </div>
        <div class="buttonsSaveImg">
          <button type="button" class="btn buttonSecondaryProperties" style="margin-left: 0;" @click="backToBeforePage">
            {{ $t('message.settingsComponent.header.cancelEditMode') }}
          </button>
          <button type="button" class="btn buttonPrimaryProperties" style="margin-left: 0;" @click="exitEditImage">
            {{ $t('message.settingsComponent.header.exitEditMode') }}
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
// import Dynamsoft from 'dwt'
import ImageCompressor from 'image-compressor.js'
import UploadFiles from '../../apiClient/UploadFiles'
import sichernDwt from '@/components/generics/dwt/DWTCaptureImage.vue'
import CaptureImage from '@/components/generics/image-capture/CaptureImage.vue'

export default {
  components: {
    DwtCaptureImage: sichernDwt,
    CaptureImage
  },
  provide() {
    return {
      editorMode: this.editorMode
    }
  },
  props: ['metadata', 'imageText', 'pdfText'],
  data() {
    return {
      files: null,
      actualImageIndex: 0,
      minimunFilesRequired: 0,
      countDocumentsToUpload: 0,
      documentsToUpload: [],
      loadId: undefined,
      uploadValidators: {
        loadCheck: 0,
        problemOnUpload: false,
        renderSendButton: false
      },
      imgSrc: false,
      step: 0,
      loading: false,
      disabled: false,
      autoDetection: false,
      countAutoDetection: 0,
      countCrop: 0,
      resetCornerPos: null,
      doneCompleted: false,
      resourcePath: process.env.VUE_APP_BASE + 'dwt-resources',
      showDwtCapture: Dynamsoft.Lib.env.bMobile ? false : true,
      showNativeCapture: false
    }
  },
  created() {
    this.uploadFiles = new UploadFiles()
    this.files = this.metadata.json.files
    this.createJsonToUpload()
  },
  updated() { },
  computed: {
    isNativeVersion() {
      return this.$store.getters.getIsNativeVersion
    }
  },
  watch: {},
  mounted() {
    this.documentsToUpload = []
    this.createJsonToUpload()
    for (let key in this.files) {
      if (this.files.hasOwnProperty(key)) {
        this.files[key].value = ''
        this.files[key].hash = ''
        this.files[key].mimeType = ''
      }
    }
  },
  methods: {
    fitPdfThumb(key) {
      this.$nextTick(() => {
        const ref = this.$refs[`ztPDFViewer_${key}`]
        const viewer = Array.isArray(ref) ? ref[0] : ref
        if (viewer && typeof viewer.zoom === 'function') {
          viewer.zoom(0.4)
        }
      })
    },
    addMbcEvent() {
      this.$refs.DWTCaptureImage.$on('change-image', () => {
        this.step = 0
      })
      this.$refs.DWTCaptureImage.$on('save-image', async (obj) => {
        this.step = 0
        const blobData = this.isNativeVersion ? obj : obj.result
        await new ImageCompressor(blobData, {
          quality: 0.5,
          maxWidth: 595, // pixels for A4 size @ 72 PPI/DPI
          maxHeight: 842, // pixels for A4 size @ 72 PPI/DPI
          convertSize: 5000000,
          success: async (result) => {
            const testBlob = Object.assign(result, { UrlOnLoad: URL.createObjectURL(result) })
            const numberRandom = Math.floor(Math.random() * 10000)
            const extensionFile = testBlob.type.split('/')[1]
            const currentImage = this.actualImageIndex

            this.files[currentImage].value = numberRandom + '.' + extensionFile
            this.files[currentImage].mimeType = testBlob.type
            this.documentsToUpload[currentImage].value = numberRandom + '.' + extensionFile
            this.documentsToUpload[currentImage].mimeType = testBlob.type
            this.$set(this.documentsToUpload[currentImage], 'file', testBlob)

            if (this.validImage(this.files[currentImage]) && testBlob.size <= 5000000) {
              this.$swal({
                type: 'success',
                title: this.$t('message.FileUploadComponent.formComponent.imageSucces'),
                showConfirmButton: true,
                confirmButtonText: this.$t('message.FileUploadComponent.swal.accept')
              })
                .then(async () => {
                  if (this.documentsToUpload[currentImage].mandatory === true) {
                    this.minimunFilesRequired++
                  }
                  this.countDocumentsToUpload++
                  await this.$refs.DWTCaptureImage.close()
                  this.imgSrc = false
                  this.$store.dispatch('go_Back_camera_Handler', true)
                })
            } else {
              this.$swal({
                type: 'error',
                title: this.$t('message.FileUploadComponent.formComponent.selectJpgPng'),
                showConfirmButton: true,
                confirmButtonText: this.$t('message.FileUploadComponent.swal.accept')
              })
            }
          }
        })
      })
      this.$refs.DWTCaptureImage.$on('load-error', () => {
        this.imgSrc = false
        this.$swal({
          type: "error",
          title: this.$t('message.FileUploadComponent.formComponent.invalidFormatFile'),
          timer: 2500,
          showConfirmButton: true,
          confirmButtonText: this.$t('message.FileUploadComponent.swal.accept')
        })
      })
    },
    createJsonToUpload() {
      let clonedObj = JSON.parse(JSON.stringify(this.files))
      for (let key in clonedObj) {
        if (clonedObj.hasOwnProperty(key)) {
          this.documentsToUpload.push(clonedObj[key])
        }
      }
    },
    async removeFilefromJson(index) {
      if (this.documentsToUpload[index].hasOwnProperty('file')) {
        this.countDocumentsToUpload--
        if (this.documentsToUpload[index].mandatory === true) {
          this.minimunFilesRequired--
        }
      }
      this.$delete(this.documentsToUpload, index)
      this.$delete(this.files, index)
    },
    deleteChoosenFile(index, item) {
      item.value = ''
      item.mimeType = ''
      this.files[index].value = ''
      this.files[index].mimeType = ''
      this.$delete(item, 'file')
      if (item.mandatory === true) {
        this.minimunFilesRequired--
      }
      this.countDocumentsToUpload--
    },
    appendNewFileToMetadata() {
      let nameSplit = this.files[0].alias.split(' ')[0]
      let numberRandom = Math.floor(Math.random() * 10000)
      let newFile = {
        alias: nameSplit + ' Agregado ',
        hash: '',
        mandatory: false,
        mimeType: '',
        name: nameSplit + '_Agregado_' + numberRandom,
        order: numberRandom,
        value: ''
      }
      let newFileForFiles = {
        alias: nameSplit + ' Agregado ',
        hash: '',
        mandatory: false,
        mimeType: '',
        name: nameSplit + '_Agregado_' + numberRandom,
        order: numberRandom,
        value: ''
      }
      this.$set(this.files, this.files.length, newFileForFiles)
      this.$set(this.documentsToUpload, this.documentsToUpload.length, newFile)
    },
    async sendDocuments(idLoad, synchronousLength, fileName) {
      return new Promise(async (resolve, reject) => {
        await this.uploadFiles
          .sendDocsToS3(
            idLoad,
            this.documentsToUpload[synchronousLength].name,
            this.documentsToUpload[synchronousLength].file
          )
          .then(response => {
            var response = response.data.results.data[0]
            response ? resolve(response) : reject()
          })
          .catch(error => {
            this.uploadValidators.problemOnUpload = true
            this.loading = false
            this.uploadValidators.loadCheck = 0
            this.$swal({
              type: 'error',
              title:
                this.$t(`message.errorReference.${error.response.data.code}`) +
                fileName,
              showConfirmButton: true,
              confirmButtonText: this.$t(
                'message.FileUploadComponent.swal.accept'
              )
            })
          })
      })
    },
    async sendDocsToS3() {
      this.uploadFiles
        .sendDocsToTemplate(this.metadata.id, this.metadata.json)
        .then(async response => {
          this.loading = true
          let idLoad = response.data.results.data[0]
          let synchronousLength = this.documentsToUpload.length - 1
          for (let index = 0; index < this.documentsToUpload.length; index++) {
            await this.sendDocuments(
              idLoad,
              synchronousLength,
              this.documentsToUpload[index].file.name
            )
              .then(response => {
                synchronousLength--
                if (response === true) {
                  this.uploadValidators.loadCheck++
                }
                this.uploadValidators.problemOnUpload = false
                if (
                  this.uploadValidators.loadCheck ===
                  this.documentsToUpload.length &&
                  this.uploadValidators.problemOnUpload === false
                ) {
                  this.uploadFiles
                    .changeLoadStatus(idLoad)
                    .then(response => {
                      this.loading = false
                      if (response.data.results.data[0] === true) {
                        let msg =
                          this.documentsToUpload.length > 1
                            ? this.$t(
                              'message.FileUploadComponent.formComponent.loadSuccess',
                              { totalDocs: this.documentsToUpload.length }
                            )
                            : this.$t(
                              'message.FileUploadComponent.formComponent.loadSuccess1'
                            )
                        this.$swal({
                          type: 'success',
                          title: msg,
                          showConfirmButton: true,
                          confirmButtonText: this.$t(
                            'message.FileUploadComponent.swal.accept'
                          )
                        })
                          .then(() => {
                            this.$emit(
                              'rollbackSelectedDoc',
                              (this.docTypeSelected = {})
                            )
                            this.$emit(
                              'nullDocMetadata',
                              (this.documentMetadata = null)
                            )
                            this.$emit('updateKey', (this.componentKey += 1))
                            this.$emit('checkLoadAprove', true)
                          })
                          .catch(error => {
                            this.$swal({
                              type: 'error',
                              title: this.$t(
                                `message.errorReference.${error.response.data.code}`
                              ),
                              showConfirmButton: true,
                              confirmButtonText: this.$t(
                                'message.FileUploadComponent.swal.accept'
                              )
                            })
                          })
                      }
                    })
                    .catch(error => {
                      this.uploadValidators.problemOnUpload = true
                      this.loading = false
                      this.uploadValidators.loadCheck = 0
                      this.$emit(
                        'rollbackSelectedDoc',
                        (this.docTypeSelected = {})
                      )
                      this.$emit(
                        'nullDocMetadata',
                        (this.documentMetadata = null)
                      )
                      this.$emit('updateKey', (this.componentKey += 1))
                      this.$swal({
                        type: 'error',
                        title: this.$t(
                          `message.errorReference.${error.response.data.code}`
                        ),
                        showConfirmButton: true,
                        confirmButtonText: this.$t(
                          'message.FileUploadComponent.swal.accept'
                        )
                      })
                    })
                }
              })
              .catch(error => {
                this.uploadValidators.problemOnUpload = true
                this.loading = false
                this.$swal({
                  type: 'error',
                  title: this.$t(
                    `message.errorReference.${error.response.data.code}`
                  ),
                  showConfirmButton: true,
                  confirmButtonText: this.$t(
                    'message.FileUploadComponent.swal.accept'
                  )
                })
              })
          }
        })
        .catch(error => {
          if (error.response.data.code === '04019') {
            this.$swal({
              type: 'error',
              title: this.$t(
                'message.FileUploadComponent.formComponent.loadAllPages'
              ),
              showConfirmButton: true,
              confirmButtonText: this.$t('message.FileUploadComponent.swal.accept')
            })
          } else {
            this.$swal({
              type: 'error',
              title: this.$t(
                `message.errorReference.${error.response.data.code}`
              ),
              showConfirmButton: true,
              confirmButtonText: this.$t('message.FileUploadComponent.swal.accept')
            })
          }
        })
    },
    choosePdfFile(index) {
      var input = document.createElement('input')
      input.type = 'file'
      input.accept = 'application/pdf'
      input.onchange = e => {
        var file = e.target.files[0]
        if (file.type === 'application/pdf' && file.size <= 5000000) {
          let renderImage = { UrlOnLoad: URL.createObjectURL(file) }
          file = Object.assign(file, renderImage)
          this.files[index].value = file.name
          this.files[index].mimeType = file.type
          this.documentsToUpload[index].value = file.name
          this.documentsToUpload[index].mimeType = file.type
          this.$set(this.documentsToUpload[index], 'file', file)
          this.countDocumentsToUpload++
          if (this.documentsToUpload[index].mandatory === true) {
            this.minimunFilesRequired++
          }
        } else if (file.type === 'application/pdf' && file.size >= 500000) {
          this.$swal({
            type: 'error',
            title: this.$t(
              'message.FileUploadComponent.formComponent.checkSizeOnPdf'
            ),
            showConfirmButton: true,
            confirmButtonText: this.$t(
              'message.FileUploadComponent.swal.accept'
            )
          })
        } else {
          this.$swal({
            type: 'error',
            title: this.$t(
              'message.FileUploadComponent.formComponent.selectPdf'
            ),
            showConfirmButton: true,
            confirmButtonText: this.$t(
              'message.FileUploadComponent.swal.accept'
            )
          })
        }
      }
      input.click()
    },
    editorMode(value) {
      this.imgSrc = value
    },
    async showFileChooseWindow(index) {
      this.actualImageIndex = index
      if (this.isNativeVersion) {
        if (!this.showNativeCapture) {
          this.showNativeCapture = true
          await this.$nextTick()
        }
        this.$refs.DWTCaptureImage.openWindow()
      } else if (!this.showDwtCapture) {
        this.showDwtCapture = true
        await navigator.mediaDevices.getUserMedia({ video: true })
        this.$refs.DWTCaptureImage.openWindow()
      } else {
        this.$refs.DWTCaptureImage.openWindow()
      }
    },
    validImage(item) {
      return item.mimeType === 'image/png' || item.mimeType === 'image/jpeg' || item.mimeType === 'image/jpg'
    },
    backToBeforePage() {
      this.$refs.DWTCaptureImage.close()
      this.$store.dispatch('go_Back_camera_Handler', true)
      this.step = 0
      this.imgSrc = false
      this.autoDetection = false
    },
    async exitEditImage() {
      this.disabled = true
      await this.$refs.DWTCaptureImage.toSave()
    },
    cropImage() {
      this.countCrop = this.countCrop + 1
      this.$refs.DWTCaptureImage.activeCropTool()
    },
    rotateImage() {
      this.$refs.DWTCaptureImage.rotate()
    },
    deleteImage() {
      this.$refs.DWTCaptureImage.close()
      this.showFileChooseWindow()
    }
  }
}
</script>
<style lang="scss" scoped>
@import './public/assets/scss/_config.scss';

.pdf-thumb {
  width: 22rem;
  max-width: 100%;
  height: 32rem;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin: 0 auto;
}
::v-deep .pdf-thumb .zt-pdf-viewer,
::v-deep .pdf-thumb [class*="zt-pdf-viewer"] {
  overflow: hidden !important;
}
::v-deep .pdf-thumb canvas {
  display: block;
  width: 100% !important;
  height: auto !important;
  max-width: 100% !important;
  /* zt-pdf-viewer reserva ~10px de SCROLLBAR_PADDING/2 internamente, lo compensamos */
  margin-left: -10px !important;
  margin-right: 0 !important;
}

.imageContainerDashboard {
  flex-direction: row;
  justify-content: center;
  display: flex;
}

.imageContentDashboard {
  width: 90%;
  align-self: center;
}

.pickers-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.containerPicker-Title {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: space-between;
}

.EliminateFieldContainer {
  display: flex;
  align-items: center;
  align-content: center;
  font-size: 16px;
  color: $bluePrimary;
  margin-bottom: 1em;
  margin-top: 1em;
}

.containerPicker-Title .icon-Close::before {
  font-size: 1.4em;
  color: $bluePrimary;
  padding-right: 1em;
}

.picker-title {
  color: #2470a0;
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  text-align: justify;
  margin-bottom: 1em;
  margin-top: 1em;
  margin-left: 1em;
}

.pdfShowContainer {
  display: flex;
  justify-content: center;
  align-content: center;
}

.containerRemoveUpload {
  background-color: #bcbcbc;
  width: 2.6em;
  height: 2.6em;
  position: absolute;
  z-index: 1;
  border-radius: 50%;
  margin-top: 10px;
  right: 50px;
  background-image: url(../../../public/assets/media/tasks/Delete.svg);
  background-size: 70% 70%;
  background-position: center;
}

.removeUpload {
  z-index: 1;
}

.removeUpload.icon-Delete::before {
  margin-left: 0.06em;
  position: absolute;
  top: 3px;
  font-size: 1.5em;
  color: black !important;
}

.filepicker-section {
  height: 14em;
  display: flex;
  justify-content: center;
  align-content: center;
  background: #f5f5f5;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  border-radius: 2px;
}

.left-picker {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-direction: column;
}

.lineSeparator {
  border-right: 1px dashed #bcbcbc;
}

.right-picker {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-direction: column;
}

.imageUpload {
  background-image: url(../../../public/assets/media/tasks/icon-image.png);
  background-size: contain;
  height: 15vw;
  width: 15vw;
  max-width: 15vw;
}

.pdfUpload {
  background-image: url(../../../public/assets/media/tasks/icon-pdf.png);
  background-size: contain;
  height: 15vw;
  width: 12vw;
  max-width: 12vw;
}

.uploadTitles {
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 3vw;
  line-height: 23px;
  color: #969696;
  text-align: center;
}

.containerButtonsSendDocs {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.btnSendDocProperties {
  margin: 0 !important;
  margin-top: 2em !important;
  width: 70%;
}

.navigateContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  margin-top: 1em;
}

.navigateArrowsContainerRight {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: flex-end;
}

.navigateArrowsContainerRight[disabled] {
  color: red;
}

.textNavigateArrows[disabled] {
  color: $grayFont !important;
}

.navigateArrowsContainerLeft {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: flex-start;
}

.image-picker {
  border-right: 1px dashed #bcbcbc;
  flex: 1;
  padding: 1rem;
}

.pdf-picker {
  flex: 1;
  padding: 1rem;
}

.picker {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.image-container {
  margin: 0 auto;
  background-size: contain;
  width: 30%;
}

.image_img {
  background-image: url(../../../public/assets/media/tasks/icon-image.png);
  height: 7vh;
}

.pdf_img {
  background-image: url(../../../public/assets/media/tasks/icon-pdf.png);
  height: 7vh;
  margin-bottom: 1em;
  margin-top: 2em;
}

.footerIcons {
  margin-top: 0.5em;
  float: none !important;
  display: flex;
  justify-content: space-around;
}

.buttonCamera {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.textButtonCamera {
  margin-top: 0.3em;
  color: $primary-color-200;
  font-size: 3vw;
}

.employeeInfo {
  margin: auto;
  margin-bottom: 0;
  font-size: 2em;
  padding: 0 1em;
}

.buttonsSaveImg {
  height: 100px;
  width: 100%;

  .btn-primary {
    font-family: Roboto, Arial, sans-serif;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    font-size: 14px;
  }

  .edit {
    color: $bluePrimary !important;
    margin-right: 10px !important;
    width: 35%;
    background-color: $white !important;
    border-color: white !important;

    &:hover {
      color: $bluePrimary !important;
    }
  }

  .save {
    width: 40%;
    margin-right: 10px !important;
  }
}

.activeAutoDetection {
  background-color: #d0d0d0;
}

@media (max-height: 640px) {
  .buttonsSaveImg {
    height: 95px;
    width: 100%;

    .btn-primary {
      font-family: Roboto, Arial, sans-serif;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      font-size: 14px;
    }

    .edit {
      color: $bluePrimary !important;
      margin-right: 10px !important;
      width: 35%;
      background-color: $white !important;
      border-color: white !important;

      &:hover {
        color: $bluePrimary !important;
      }
    }

    .save {
      width: 40%;
      margin-right: 10px !important;
    }
  }
}

@media (min-width: 320px) and (max-width: 330px) {
  .buttonsSaveImg {
    height: 75px;
    width: 100%;

    .btn-primary {
      font-family: Roboto, Arial, sans-serif;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      font-size: 14px;
    }

    .edit {
      color: $bluePrimary !important;
      margin-right: 10px !important;
      width: 35%;
      background-color: $white !important;
      border-color: white !important;

      &:hover {
        color: $bluePrimary !important;
      }
    }

    .save {
      width: 40%;
      margin-right: 10px !important;
    }
  }
}

.mbc {
  height: 100%;
  width: 100%;
  background: rgb(250, 250, 250) !important;
  padding: 3.6rem 0 0 0 !important;
}

.pie {
  min-height: 65px;
  color: $white;
  text-align: center;
  left: 0;
  width: 100%;
  padding: 0;
  margin-left: 0 !important;
}

.loadNewImage {
  color: $textSecondary;
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  text-align: justify;
  margin-bottom: 1em;
  margin-top: 1em;
  margin-left: 1em;
}

.loadNewImage .icon-Plus {
  overflow: hidden;
  font-size: 1em;
}

.loadNewImage .icon-Plus::before {
  color: $textSecondary;
  font-size: 1.3em;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.container.grid-list-xl.column.fill-height {
  margin-top: 0 !important;
}

.flex {
  padding: 0 !important;
}

.svgUpload {
  height: 42px;
  width: 42px;
}

.svgUploadPad {
  padding: 7px;
}

.buttonCamera {
  padding: 8px 16px;
  border-radius: 6px;
  width: 100px;

  &:hover {
    background-color: #cbd5e0;
  }

  &:active {
    background-color: #cbd5e0;
  }

  &:visited {
    background-color: #cbd5e0;
  }

  &:focus {
    outline-color: unset !important;
  }
}

.deleteImage {
  color: #dd614a;
  margin: 14px 0;
}

#mbcCamera {
  padding-top: 56px;
}

.deleteImage {
  &:hover {
    outline-color: unset !important;
  }

  &:active {
    outline-color: unset !important;
  }

  &:visited {
    outline-color: unset !important;
  }

  &:focus {
    outline-color: unset !important;
  }
}

.centerAux {
  margin-left: 3rem;
}

.loadOptionWrapper {
  height: 48px;

  display: flex;
  background-color: white;
  padding-top: 12px;
  -webkit-box-shadow: 0 3px 7px -1px rgba(0, 0, 0, 0.56);
  -moz-box-shadow: 0 3px 7px -1px rgba(0, 0, 0, 0.56);
  box-shadow: 0 3px 7px -1px rgba(0, 0, 0, 0.56);
}

.loadOptionContainer {
  height: 30px;
  display: block;
}

.loadOptionText {
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 20px;
  color: #969696;
}

.loadOptionIcon {
  float: left;
  margin: 0 4px;
}

.zt-icon {
  font-size: 2.5rem;
  align-self: center;
  color: #6f6f6f;
}

.icon-Crop:before,
.icon-Rotate:before,
.icon-Detect:before {
  color: $primary-color-200;
  font-size: 40px;
}

.edit-image {
  position: fixed;
  z-index: 100;
  background-color: $white;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.kPainterBoxBackground {
  background: none !important;
  margin-bottom: 0;
  margin-top: -40px;
}
</style>
